module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-wrapper"
  }, [_c('div', {
    staticClass: "header",
    style: ({
      backgroundColor: _vm.cssPropColor('$color-primary')
    })
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('label', {
    attrs: {
      "for": "panel-toggle",
      "title": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closePanel($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon-MBR_close",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "label",
    domProps: {
      "innerHTML": _vm._s(_vm.addCoverageLabel)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "panel-content",
    attrs: {
      "data-simplebar": ""
    }
  }, [_c('ul', {
    staticClass: "accordion"
  }, [(_vm.hasServiceLineCoverages) ? _c('li', {
    attrs: {
      "data-type": "service-line"
    }
  }, [_c('a', {
    attrs: {
      "id": "anchor_service-line",
      "name": "anchor_service-line"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "checkbox",
      "id": "tab-service-line",
      "name": "outer-tabs[]",
      "data-coverage": "service-line"
    },
    domProps: {
      "checked": _vm.service
    },
    on: {
      "change": function($event) {
        _vm.toggleOuterCheck($event, 'tab-service-line')
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-heading",
    attrs: {
      "for": "tab-service-line"
    }
  }, [_c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.serviceLineLabel)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [(_vm.serviceLineLeadIn) ? _c('div', {
    staticClass: "lead-in service-line",
    domProps: {
      "innerHTML": _vm._s(_vm.serviceLineLeadIn)
    }
  }) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "coverage-links"
  }, _vm._l((_vm.serviceLineCoverages), function(coverage) {
    return _c('li', [_c('a', {
      domProps: {
        "innerHTML": _vm._s(coverage.exposure_label)
      },
      on: {
        "click": function($event) {
          _vm.togglePanel('panel-content-exposure', coverage.exposure_slug, $event, true, false)
        }
      }
    })])
  }))]), _vm._v(" "), _c('hr')]) : _vm._e(), _vm._v(" "), (_vm.hasOffPremiseCoverages) ? _c('li', {
    attrs: {
      "data-type": "off-premise"
    }
  }, [_c('a', {
    attrs: {
      "id": "anchor_off-premise",
      "name": "anchor_off-premise"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "checkbox",
      "id": "tab-off-premise",
      "name": "outer-tabs[]",
      "data-coverage": "off-premise"
    },
    domProps: {
      "checked": _vm.premise
    },
    on: {
      "change": function($event) {
        _vm.toggleOuterCheck($event, 'tab-off-premise')
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-heading",
    attrs: {
      "for": "tab-off-premise"
    }
  }, [_c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.offPremiseLabel)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [(_vm.offPremiseLeadIn) ? _c('div', {
    staticClass: "lead-in",
    domProps: {
      "innerHTML": _vm._s(_vm.offPremiseLeadIn)
    }
  }) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "coverage-links"
  }, _vm._l((_vm.offPremiseCoverages), function(coverage) {
    return _c('li', [_c('a', {
      domProps: {
        "innerHTML": _vm._s(coverage.exposure_label)
      },
      on: {
        "click": function($event) {
          _vm.togglePanel('panel-content-exposure', coverage.exposure_slug, $event, false, true)
        }
      }
    })])
  }))]), _vm._v(" "), _c('hr')]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "contact-link"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.contact.text)
    }
  }), _vm._v(" "), _c('br'), _c('a', {
    domProps: {
      "innerHTML": _vm._s(_vm.contact.link.label)
    },
    on: {
      "click": function($event) {
        _vm.togglePanel2('panel-content-contact', 'contact-us', $event, false, false)
      }
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-654071da","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PanelContentCoverages.vue
// module id = 460
// module chunks = 1